import constants from "../Utils/constants";
const initialState = {
  isGetEnquiryLoading: false,
  isCreateEnquiryLoading: false,
  isUpdateEnquiryLoading: false,
  isDeletInquiryLoading:false,
  enquiries: [],
};

const enquiriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ENQUIRIES_REQUEST:
      return {
        ...state,
        isGetEnquiryLoading: true,
      };
    case constants.GET_ENQUIRIES_SUCCESS:
      return {
        ...state,
        isGetEnquiryLoading: false,
        enquiries: action.payload,
      };
    case constants.GET_ENQUIRIES_FAILURE:
      return {
        ...state,
        isGetEnquiryLoading: false,
      };

    case constants.CREATE_ENQUIRY_REQUEST:
      return {
        ...state,
        isCreateEnquiryLoading: true,
      };
    case constants.CREATE_ENQUIRY_SUCCESS:
      return {
        ...state,
        isCreateEnquiryLoading: false,
      };
    case constants.CREATE_ENQUIRY_FAILURE:
      return {
        ...state,
        isCreateEnquiryLoading: false,
      };

    case constants.UPDATE_CLIENT_REQUEST:
      return {
        ...state,
        isUpdateEnquiryLoading: true,
      };
    case constants.UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        isUpdateEnquiryLoading: false,
      };
    case constants.UPDATE_CLIENT_FAILURE:
      return {
        ...state,
        isUpdateEnquiryLoading: false,
      };

    case constants.DELETE_ENQUIRY_REQUEST:
      return {
        ...state,
        isDeletInquiryLoading: true,
      };
    case constants.DELETE_ENQUIRY_SUCCESS:
      return {
        ...state,
        isDeletInquiryLoading: false,
      };
    case constants.DELETE_ENQUIRY_FAILURE:
      return {
        ...state,
        isDeletInquiryLoading: false,
      };
    case "REMOVING_USER_CREDENTIALS":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
export default enquiriesReducer;
